var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeparador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1937.6 160.1",
    style: {
      enableBackground: "new 0 0 1937.6 160.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t\n\t\t.st1{fill:none;stroke:#FF345A;stroke-width:2.8363;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4.0018;stroke-dasharray:12.0054;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_23_1_",
    className: "st0",
    d: "M1936.2,160.1H1.4V106c0,0,19.9,40.4,109.8,46.7S361.1,16.5,494.7,25.9S778,122.6,915.9,132.3 S1219.6,1,1338.1,9.3c118.5,8.3,151.9,56.1,285.5,65.5s312.6-73.3,312.6-73.3V160.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    className: "st1",
    d: "M1.4,106c0,0,19.9,40.4,109.8,46.7S361.1,16.5,494.7,25.9S778,122.6,915.9,132.3 S1219.6,1,1338.1,9.3c118.5,8.3,151.9,56.1,285.5,65.5s312.6-73.3,312.6-73.3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparador);
export default __webpack_public_path__ + "static/media/separador.29680654.svg";
export { ForwardRef as ReactComponent };